import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import { FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { IFormTypes } from '../../data/form-types';
import { LookupItem } from '../../models/lookup-item';
import { ApplicantDetails } from '../../data/applicant-details';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { AssessmentService } from '../../services/assessment.service';
import { IFormComponent } from '../../models/i-form-component';
import { ILookup } from '../../data/Ilookup';
import { IVisaType } from '../../data/visa-type';
import { OptionItem } from '../../data/option-item';

// Australian date formats
// const AU_DATE_FORMATS = {
//   parse: {
//     dateInput: 'DD/MM/YYYY',
//   },
//   display: {
//     dateInput: 'DD/MM/YYYY',
//     monthYearLabel: 'MMM YYYY',
//     dateA11yLabel: 'DD/MM/YYYY',
//     monthYearA11yLabel: 'MMMM YYYY',
//   },
// };

@Component({
  selector: 'app-applicant-details',
  templateUrl: './applicant-details.component.html',
  styleUrls: ['./applicant-details.component.scss']
})
export class ApplicantDetailsComponent implements OnInit, IFormComponent {
  @Input()model!: InitialAssessmentForm;
  @Input()isAddressForced: boolean = false;
  @Input()formTypes!: IFormTypes;
  @Input()formSubmitted: boolean = false;
  @Input() countries!: LookupItem[];
  @Input() visaTypes!: IVisaType[];
  @Input() titles!: LookupItem[];
  @Input() maritalStatus!: LookupItem[];
  @Input() phoneTypes!: OptionItem[];
  @Input() enquiryType: string = '';
  @Output() formReady = new EventEmitter<FormGroup>();

  applicantText: any;
  selectedForm: any;
  isVevo: boolean = false;
  isVevoEmployee: boolean = false;
  isVevoContract: boolean = false;
  isGeneric: boolean = false;
  isAppealRefuse: boolean = false;
  isAppealCancel: boolean = false;
  isStudy: boolean = false;

  constructor(private assessmentService: AssessmentService) {

  }
  isFormValid(): boolean {
    return this.applicantDetailsForm.valid;
  }
  markFormAsTouched(): void {
    this.applicantDetailsForm.markAllAsTouched();
  }

  formBuilder = inject(NonNullableFormBuilder);

  applicantDetailsForm = this.formBuilder.group({
  dob: [''],
  title: [null as ILookup | null],
  titleOther: [''],
  firstName: [''],
  surname: [''],
  email: [''],
  phoneType: [null as OptionItem | null],
  phoneCountryCode: [''],
  phoneAreaCode: [''],
  phoneNumber: [''],
  currentResidentialAddress: this.formBuilder.group({
    streetAddress: [''],
    city: [''],
    state: [''],
    postcode: [''],
    country: ['']
  }),
  passportNumber: [''],
  passportCountry: [null as ILookup | null],
  inAustralia: [''],
  location: [null as ILookup | null],
  arriveAustralia: [''],
  departAustralia: [''],
  holdAustralianVisa: [''],
  visaType: [null as IVisaType | null],
  visaExpire: [''],
  maritalStatus: [null as LookupItem | null],
  partnerCitizen: [''],
  inDetention: [''],
  detentionFacility: [''],
  acceptedForStudy: [''],
  nameOfCourse: [''],
  enrolmentConfirmation: [''],
  studyReasons: ['']
});


  ngOnInit() {
    
    this.applicantText = this.assessmentService.applicantText();
    this.selectedForm = this.assessmentService.selectedForm();
    this.isVevo = this.assessmentService.isVevo();
    this.isVevoEmployee = this.assessmentService.isVevoEmployee();
    this.isVevoContract = this.assessmentService.isVevoContract();
    this.isGeneric = this.assessmentService.isGeneric();
    this.isAppealRefuse = this.assessmentService.isAppealRefuse();
    this.isAppealCancel = this.assessmentService.isAppealCancel();
    this.isStudy = this.assessmentService.isStudy();
    this.initializeForm();
    this.setupValidators();
    
    this.formReady.emit(this.applicantDetailsForm);

  }


  initializeForm(){
        
    this.model = this.model || new InitialAssessmentForm();
    this.model.applicantDetails = this.model.applicantDetails || new ApplicantDetails();
      
    this.applicantDetailsForm?.patchValue(this.model.applicantDetails);
    
    this.applicantDetailsForm.valueChanges.subscribe(value => {
      if (this.model.applicantDetails && value) {
          Object.assign(this.model.applicantDetails, {
          ...value,
          currentResidentialAddress: {
            ...this.model.applicantDetails.currentResidentialAddress,
            ...value.currentResidentialAddress
          }
        });

        this.updateConditionalValidators();
      }
    });

  }

  setupValidators(){
    const dobControl = this.applicantDetailsForm.controls.dob;
    const firstNameControl = this.applicantDetailsForm.controls.firstName;
    const surnameControl = this.applicantDetailsForm.controls.surname;
    const emailControl = this.applicantDetailsForm.controls.email;
    const inAustraliaControl = this.applicantDetailsForm.controls.inAustralia;

    if (this.isVevo) {
      dobControl?.setValidators([Validators.required]);
      this.applicantDetailsForm.controls.passportNumber?.setValidators([Validators.required]);
      this.applicantDetailsForm.controls.passportCountry?.setValidators([Validators.required]);
    }

 
    if (this.isFirstNameRequired()) {
      firstNameControl?.setValidators([Validators.required]);
    }

    if (this.isSurnameRequired()) {
      surnameControl?.setValidators([Validators.required]);
    }

    if (this.isEmailRequired()) {
      emailControl?.setValidators([Validators.required, Validators.email]);
    } else {
      emailControl?.setValidators([Validators.email]);
    }

    
    if(this.isAddressForced){
      inAustraliaControl.setValidators([Validators.required]);
      inAustraliaControl.updateValueAndValidity({ emitEvent: false });
    }


    // Update form validity
    this.applicantDetailsForm.updateValueAndValidity();
  }

private updateConditionalValidators(): void {
  this.updateAddressValidation();
  this.updateStudyValidation();

}


private updateAddressValidation(): void {
  const inAustraliaControl = this.applicantDetailsForm.controls.inAustralia;
  const addressGroup = this.applicantDetailsForm.controls.currentResidentialAddress as FormGroup;
  
  const shouldRequireAddress = this.shouldRequireAddress(inAustraliaControl.value);
  
  if (addressGroup && shouldRequireAddress) {
    ['streetAddress', 'city', 'state', 'postcode', 'country'].forEach(field => {
      addressGroup.get(field)?.setValidators([Validators.required]);
      addressGroup.get(field)?.updateValueAndValidity({ emitEvent: false });
    });
  } else if (addressGroup) {
    ['streetAddress', 'city', 'state', 'postcode', 'country'].forEach(field => {
      addressGroup.get(field)?.clearValidators();
      addressGroup.get(field)?.updateValueAndValidity({ emitEvent: false });
    });
  }
}

public shouldRequireAddress(inAustralia: string): boolean {
  
 return (inAustralia === 'true' || inAustralia === 'false') && this.isAddressForced;
  
}


private updateStudyValidation(): void {
  const acceptedForStudy = this.applicantDetailsForm.controls.acceptedForStudy?.value;
  const courseNameControl = this.applicantDetailsForm.controls.nameOfCourse;
  const enrolmentControl = this.applicantDetailsForm.controls.enrolmentConfirmation;
  
  if (this.isStudy && acceptedForStudy === 'true') {
    // Course name is required when accepted for study
    courseNameControl?.setValidators([Validators.required]);
    // From old template: Enrolment confirmation also becomes required
    enrolmentControl?.setValidators([Validators.required]);
  } else {
    courseNameControl?.clearValidators();
    enrolmentControl?.clearValidators();
  }
  
  courseNameControl?.updateValueAndValidity({ emitEvent: false });
  enrolmentControl?.updateValueAndValidity({ emitEvent: false });
}

  // Intial Validation helpers
isFirstNameRequired(): boolean {
  return !this.isGeneric || (this.isGeneric && this.enquiryType !== 'business');
}
isSurnameRequired(): boolean {
  return !this.isGeneric || (this.isGeneric && this.enquiryType !== 'business');
}

isEmailRequired(): boolean {
  return (!this.isGeneric || (this.isGeneric && this.enquiryType !== 'business')) && !this.isVevoEmployee && !this.isVevoContract;
}



}